// Import from context
import { useEffect } from "react";
import { useAirQualityContext } from "../context/AirQualityProvider";

// Re-export types and constants for backward compatibility
export type { AirQualityLocation, ProcessedAirQualityData } from "../context/AirQualityProvider";
export { AVAILABLE_LOCATIONS, DEFAULT_LOCATION_ID } from "../context/AirQualityProvider";

/**
 * Hook do pobierania danych jakości powietrza
 * Używa globalnego contextu AirQualityProvider
 * 
 * @param selectedLocationId - Opcjonalny ID lokalizacji do ustawienia
 * @returns Obiekt z danymi jakości powietrza i metodami do zarządzania
 */
export function useAirQuality(selectedLocationId?: string) {
  const context = useAirQualityContext();

  // Aktualizuj lokalizację jeśli została przekazana jako prop
  useEffect(() => {
    if (selectedLocationId && selectedLocationId !== context.currentLocation.id) {
      context.setLocation(selectedLocationId);
    }
  }, [selectedLocationId, context]);

  return {
    airQuality: context.airQuality,
    isLoading: context.isLoading,
    error: context.error,
    allStations: [], // Nie jest już używane, ale zachowujemy dla kompatybilności
    isFromCache: context.isFromCache,
    currentLocation: context.currentLocation,
    availableLocations: context.availableLocations,
    setLocation: context.setLocation,
    refetch: context.refetch,
  };
}
